<template>
  <v-btn
    rounded
    small
    text
    color="secondary"
    @click="imprimirXml()"
    :icon="isMobile()"
  >
    <v-icon :left="!isMobile()">mdi-xml</v-icon> <span v-if="!isMobile()">XML</span></v-btn
  >
</template>

<script>
import { getToken } from "@/global";

export default {
  props: {
    nf: Object,
  },
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
    imprimirXml() {
      window.open(
        `${
          process.env.VUE_APP_BASE_URL
        }/nutricao-animal/downloads/download-xml?token=${getToken()}&nf=${
          this.nf.id
        }&p=${this.nf.pessoa}`,
        "_blank"
      );
    },
  },
};
</script>

<style>
</style>